const getAdditionalFields = (intl) => [
  {
    children: intl.formatMessage({
      defaultMessage: 'Do Not Use',
      id: 'e966c',
    }),
    id: 'DoNotUse',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Is Licensed',
      id: '9ab77',
    }),
    id: 'Is Licensed',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Alignment Status',
      id: '3a2f2',
    }),
    id: 'AlignmentStatus',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Kickoff / Period End Missing',
      id: '47547',
    }),
    id: 'Missing Minutes',
  },
];

export const getHeadings = (intl, isSmallScreen) => [
  {
    children: intl.formatMessage({
      defaultMessage: 'Period',
      id: '19016',
    }),
    id: 'Part',
  },
  {
    children: intl.formatMessage({
      defaultMessage: 'Video Info',
      id: '28f69',
    }),
    id: 'VideoInfo',
  },
  ...(isSmallScreen
    ? []
    : [
        {
          children: intl.formatMessage({
            defaultMessage: 'Video Source',
            id: '55951',
          }),
          id: 'VideoSource',
        },
        ...getAdditionalFields(intl),
      ]),
  {
    children: intl.formatMessage({
      defaultMessage: 'Actions',
      id: '06df3',
    }),
    id: 'Actions',
  },
  ...(isSmallScreen
    ? []
    : [
        {
          children: intl.formatMessage({
            defaultMessage: 'Last Modified',
            id: '84ba4',
          }),
          id: 'Last Modified',
        },
      ]),
];

export const getAlignmentStatus = (video, intl) => {
  const isStream = !!video?.stream_url;
  if (!isStream) return '-';

  const isAligned = video?.is_aligned;
  if (isAligned === true)
    return intl.formatMessage({
      defaultMessage: 'Aligned',
      id: '1d5b7',
    });
  if (isAligned === false)
    return intl.formatMessage({
      defaultMessage: 'Misaligned',
      id: '5df81',
    });
  return intl.formatMessage({
    defaultMessage: 'Pending',
    id: '2d13d',
  });
};
